import script from "./BindPhoneDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindPhoneDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BindPhoneDialog.vue?vue&type=style&index=0&id=0b9d7662&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9d7662"]])

export default __exports__